import styled, { css } from 'styled-components'
import { pxToRem } from 'styles/functions'

interface StyledCheckboxProps {
  theme: any;
  $disabled: boolean;
}
// on ios, flex resizes input size
export const StyledCheckbox = styled.label<StyledCheckboxProps>`
  position: relative;
  display: flex;
  flex-direction: row;
  width: inherit;
  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};
  ${({ $disabled }) => $disabled && 'pointer-events: none;'}

  p {
    flex: 2;
    margin-left: ${pxToRem(10)};

    ${({ $disabled }) =>
            $disabled &&
            css`
              color: #6c757d;
            `}
  }

  input {
    flex: 1;
    max-width: ${pxToRem(20)};

    ${({ $disabled }) =>
            $disabled &&
            css`
              background-color: #eeeeee !important;
              border-color: #eeeeee !important;
            `}
  }
`

interface StyledCheckmarkProps {
  theme: any;
  $checked: boolean;
  $disabled: boolean;
}
export const StyledCheckmark = styled.span<StyledCheckmarkProps>`
  &:after {
    visibility: ${({ $checked }) => ($checked ? 'visible' : 'hidden')};
    content: '';
    display: block;
    border: solid ${({ theme }) => theme.input_checkmark_color || '#3aac6b'};
    border-width: 0 ${pxToRem(3)} ${pxToRem(3)} 0;
    transform: rotate(45deg);
    position: absolute;
    width: ${pxToRem(7)};
    height: ${pxToRem(14)};
    left: ${pxToRem(7)};
    top: ${pxToRem(2)};

    ${({ $disabled }) =>
            $disabled &&
            css`
              border-color: #6c757d;
              opacity: 0.6;
            `}
  }
`
